module.exports = __webpack_public_path__ + "static/Rat@2x.b9df2676.png";